import './404Page.css';

function Error() {
    return (
        <div style={{ height: '800px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <p style={{ fontSize: '40px' }}>Page Not Found</p>
        </div>
    );
}

export default Error;
